import { render, staticRenderFns } from "./ShowTaskModal.vue?vue&type=template&id=303ff1aa"
import script from "./ShowTaskModal.vue?vue&type=script&lang=js"
export * from "./ShowTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports